// This file was automatically generated from print.billing.html.
// Please don't edit this file by hand.

goog.provide('el8.template.print.billing');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.print');
goog.require('el8.template.ptdata.model.note');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.billing.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="pageBreak pageWrap">');
  el8.template.print.header(opt_data, output);
  output.append('<h1 class="documentTitle">', (opt_data.isExactDate) ? 'Provider Billing Report - Visit Notes on ' + (soy.$$escapeHtml(opt_data.requestedDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.requestedDate)) : '') : 'Provider Billing Report - All Visit Notes To Be Billed', '</h1><div class="billingInfo">', (opt_data.physician) ? '<p class="billingProviderName">Provider Name: ' + soy.$$escapeHtml(opt_data.physician.name) + '</p>' : '', '<p>Printed: ', (soy.$$escapeHtml(opt_data.now)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.now)) : ''), '</p></div>');
  if (opt_data.isEmpty) {
    output.append((opt_data.isExactDate) ? '<h2 class="reportHeader">No visit notes to display</h2>' : '<h2 class="reportHeader">No unbilled visit notes to display</h2>');
  } else {
    if (opt_data.unbilledSigned.length) {
      output.append('<h2 class="reportHeader">Signed Visit Notes Not Yet Billed</h2><table class="providerReport billingReport">');
      el8.template.print.billing.tableHeaders(opt_data, output);
      var bList12182 = opt_data.unbilledSigned;
      var bListLen12182 = bList12182.length;
      for (var bIndex12182 = 0; bIndex12182 < bListLen12182; bIndex12182++) {
        var bData12182 = bList12182[bIndex12182];
        el8.template.print.billing.billItem(soy.$$augmentData(bData12182, {isInvoicingEnabled: opt_data.isInvoicingEnabled}), output);
      }
      output.append('</table>');
    }
    if (opt_data.unbilledUnsigned.length) {
      output.append('<h2 class="reportHeader">Visit Notes Awaiting Physician Sign-Off, Not Yet Billed</h2><table class="providerReport billingReport">');
      el8.template.print.billing.tableHeaders(opt_data, output);
      var bList12191 = opt_data.unbilledUnsigned;
      var bListLen12191 = bList12191.length;
      for (var bIndex12191 = 0; bIndex12191 < bListLen12191; bIndex12191++) {
        var bData12191 = bList12191[bIndex12191];
        el8.template.print.billing.billItem(soy.$$augmentData(bData12191, {isInvoicingEnabled: opt_data.isInvoicingEnabled}), output);
      }
      output.append('</table>');
    }
    if (opt_data.vendorResponsible.length) {
      output.append('<h2 class="reportHeader">Visit Notes Awaiting Vendor Response</h2><table class="providerReport billingReport">');
      el8.template.print.billing.tableHeaders(opt_data, output);
      var bList12200 = opt_data.vendorResponsible;
      var bListLen12200 = bList12200.length;
      for (var bIndex12200 = 0; bIndex12200 < bListLen12200; bIndex12200++) {
        var bData12200 = bList12200[bIndex12200];
        el8.template.print.billing.billItem(soy.$$augmentData(bData12200, {isInvoicingEnabled: opt_data.isInvoicingEnabled}), output);
      }
      output.append('</table>');
    }
    if (opt_data.billed.length) {
      output.append('<h2 class="reportHeader">Visit Notes Marked as Billed</h2><table class="providerReport billingReport">');
      el8.template.print.billing.tableHeaders(opt_data, output);
      var bList12209 = opt_data.billed;
      var bListLen12209 = bList12209.length;
      for (var bIndex12209 = 0; bIndex12209 < bListLen12209; bIndex12209++) {
        var bData12209 = bList12209[bIndex12209];
        el8.template.print.billing.billItem(soy.$$augmentData(bData12209, {isInvoicingEnabled: opt_data.isInvoicingEnabled}), output);
      }
      output.append('</table>');
    }
  }
  output.append('</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.billing.tableHeaders = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<tr class="providerReportTitle"><th>Date</th><th>Patient</th><th class="billingCPT">CPT</th><th>Dx</th>', (opt_data.isInvoicingEnabled) ? '<th>Charge</th>' : '', (el8Globals.FEATURES.FrontOfficeNewKareo) ? '<th>Patient Payment</th>' : '', '<th>Notes</th></tr>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.billing.billItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<tr><td class="date">', (soy.$$escapeHtml(opt_data.noteDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.noteDate)) : ''), '</td><td class="name"><span>', soy.$$escapeHtml(opt_data.patientName), '</span><br><span>(D.O.B.: ', (soy.$$escapeHtml(opt_data.patientDob)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.patientDob)) : ''), ')</span>', (opt_data.patientInsurance) ? '<br><span class="extraSmallText">Insurance: ' + soy.$$escapeHtml(opt_data.patientInsurance.carrier) + ((opt_data.patientInsurance.plan) ? ' ' + soy.$$escapeHtml(opt_data.patientInsurance.plan) : '') + '; ' + soy.$$escapeHtml(opt_data.patientInsurance.groupId) + '; ' + soy.$$escapeHtml(opt_data.patientInsurance.memberId) + '</span>' : '', (opt_data.patientSecondaryInsurance) ? '<br><span class="extraSmallText">2nd Insurance: ' + soy.$$escapeHtml(opt_data.patientSecondaryInsurance.carrier) + ((opt_data.patientSecondaryInsurance.plan) ? ' ' + soy.$$escapeHtml(opt_data.patientSecondaryInsurance.plan) : '') + '; ' + soy.$$escapeHtml(opt_data.patientSecondaryInsurance.groupId) + '; ' + soy.$$escapeHtml(opt_data.patientSecondaryInsurance.memberId) + '</span>' : '', '</td>', (opt_data.isInvoicingEnabled) ? '<td colspan="3" class="billingCode">' : '<td colspan="2" class="billingCode">', '<table class="billingCodeTable">');
  var cList12267 = opt_data.cpts;
  var cListLen12267 = cList12267.length;
  for (var cIndex12267 = 0; cIndex12267 < cListLen12267; cIndex12267++) {
    var cData12267 = cList12267[cIndex12267];
    output.append('<tr><td class="billingCPT">');
    el8.template.ptdata.model.note.cptWithModifiers(cData12267, output);
    output.append('</td><td class="billingICD9"><ul class="list">');
    var dList12271 = cData12267.dxs;
    var dListLen12271 = dList12271.length;
    for (var dIndex12271 = 0; dIndex12271 < dListLen12271; dIndex12271++) {
      var dData12271 = dList12271[dIndex12271];
      output.append('<li class="itemBullet">', (dData12271.icd10Code) ? '<span class="el8Bold">' + soy.$$escapeHtml(dData12271.icd10Code.code) + '</span>' : '');
      if (dData12271.icd9Codes && dData12271.icd9Codes.length) {
        output.append('<br />');
        var icd9CodeList12281 = dData12271.icd9Codes;
        var icd9CodeListLen12281 = icd9CodeList12281.length;
        for (var icd9CodeIndex12281 = 0; icd9CodeIndex12281 < icd9CodeListLen12281; icd9CodeIndex12281++) {
          var icd9CodeData12281 = icd9CodeList12281[icd9CodeIndex12281];
          output.append('(', soy.$$escapeHtml(icd9CodeData12281.code), ')', (! (icd9CodeIndex12281 == icd9CodeListLen12281 - 1)) ? '<br />' : '');
        }
      }
      output.append((dData12271.dx) ? soy.$$escapeHtml(dData12271.dx) : '', '</li>');
    }
    output.append('</ul></td>', (opt_data.isInvoicingEnabled) ? '<td class="billingUnitCharge">' + ((cData12267.units && cData12267.charge) ? soy.$$escapeHtml(cData12267.units) + ' x ' + (soy.$$escapeHtml(cData12267.charge)? el8.util.string.formatMoney(soy.$$escapeHtml(cData12267.charge)) : '') : '') + '</td>' : '', '</tr>');
  }
  output.append('</table></td>', (el8Globals.FEATURES.FrontOfficeNewKareo) ? '<td class="billingPayment">' + ((opt_data.copayCollected) ? (soy.$$escapeHtml(opt_data.copayCollected.amount)? el8.util.string.formatMoney(soy.$$escapeHtml(opt_data.copayCollected.amount)) : '') : '--') + '</td>' : '', '<td class="billingNotes">', (opt_data.serviceLocation) ? 'Location: ' + soy.$$escapeHtml(opt_data.serviceLocation) + '<br/>' : '', soy.$$escapeHtml(opt_data.notes), '</td></tr>');
  if (!opt_sb) return output.toString();
};
